import { pick } from "accept-language-parser";
import { cleanDoubleSlashes, parseURL } from "ufo";

import { needToNormalize, normalizeUrl } from "~/shared/utils/normalize-url";

export default {
  defaultNS: "common",
};

export function getFromSupported(
  language: string | null,
  supported: Array<string>,
  fallback: string,
): string {
  return pick(supported, language ?? fallback, { loose: true }) ?? fallback;
}

export const detectLanguageAndRegion = (
  request: Request,
  supportedLngs: Array<string>,
  fallbackLng: string,
): { language: string } => {
  const { pathname } = parseURL(request.url);
  const [_, lng] = pathname.split("/");

  return {
    language: getFromSupported(
      typeof lng === "string" ? lng : null,
      supportedLngs,
      fallbackLng,
    ),
  };
};
export const changeLanguage = (locale: LanguageCode): void => {
  if (typeof window === "undefined") {
    throw new Error('"changeLanguage" is client-only method');
  }

  const pathname = location.pathname;
  const [_, _lng, ...otherSegments] = pathname.split("/");
  const newPath = [locale, ...otherSegments].join("/");
  let href = `${cleanDoubleSlashes(`/${newPath}/`)}${location.search ? `${location.search}` : ""}${location.hash ? `${location.hash}` : ""}`;

  if (needToNormalize(href)) {
    href = normalizeUrl(href);
  }
  location.href = href;
};

export const generateUrlWithLocale = (
  path: string,
  locale: LanguageCode,
): string => {
  const { search, hash, pathname } = parseURL(path);

  let url = `/${locale}${pathname}${search ? `?${search}` : ""}${hash ? `#${hash}` : ""}`;
  if (needToNormalize(url)) {
    url = normalizeUrl(url);
  }
  return url;
};
